import { CartAddEvent } from '@theme/events';

/**
 * Cart "You may also like" row.
 *
 * Each card has an optional size <select> and an ADD button. Clicking ADD posts
 * the selected variant to /cart/add.js (requesting every cart-items-component
 * section back) and dispatches a CartAddEvent so the drawer — including this
 * recommendations row — re-renders in place and drops the just-added product.
 */
class SstCartRecommendations extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  /** @param {MouseEvent} event */
  #handleClick = (event) => {
    const target = /** @type {HTMLElement} */ (event.target);
    const button = target.closest('[data-rec-add]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    event.preventDefault();
    this.#addToCart(button);
  };

  /** @param {HTMLButtonElement} button */
  async #addToCart(button) {
    const card = button.closest('.sst-cart-rec');
    if (!(card instanceof HTMLElement)) return;

    const sizeSelect = card.querySelector('[data-rec-size]');
    const variantId =
      sizeSelect instanceof HTMLSelectElement && sizeSelect.value
        ? sizeSelect.value
        : button.dataset.defaultVariantId;
    if (!variantId) return;

    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : null))
      .filter(Boolean);

    button.disabled = true;
    card.classList.add('is-loading');

    try {
      const response = await fetch(`${Theme.routes.cart_add_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sectionIds.join(','),
        }),
      }).then((res) => res.json());

      if (response.status) {
        // Add failed (e.g. sold out). Surface nothing destructive; just re-enable.
        button.disabled = false;
        card.classList.remove('is-loading');
        return;
      }

      const cart = await fetch(`${Theme.routes.cart_url}.js`).then((res) => res.json());

      document.dispatchEvent(
        new CartAddEvent(cart, 'sst-cart-recommendations', {
          source: 'sst-cart-recommendations',
          itemCount: cart?.item_count,
          variantId: String(variantId),
          sections: response.sections,
        })
      );
    } catch (error) {
      console.error(error);
      button.disabled = false;
      card.classList.remove('is-loading');
    }
  }
}

if (!customElements.get('sst-cart-recommendations')) {
  customElements.define('sst-cart-recommendations', SstCartRecommendations);
}
